import React from 'react';
import { Tag } from './StatusTag.styles';
/**
 * Status Tag component
 */
export const StatusTag = ({ text, color, width, title, fontSize, lineHeight, }) => (React.createElement(Tag, { width: width, color: color, title: title, fontSize: fontSize, lineHeight: lineHeight }, text.toUpperCase()));
export default StatusTag;
